import { addCacheKey } from '@redux/reducers/commands.reducer'
import { store } from '@redux/store'

import { COMMAND_CACHE_TIME } from '@constants'

export const isUseCommandDataFromCache = (cacheKey: string) => {
  const state = store.getState()

  const timestamp = state.commands.cacheKeys[cacheKey]
  const currentTime = Date.now()
  const diffInMs = currentTime - timestamp

  if (!timestamp || diffInMs > COMMAND_CACHE_TIME) {
    store.dispatch(addCacheKey(cacheKey))

    return false
  }

  return true
}
